import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Breadcrumb, BreadcrumbItem, Container } from 'reactstrap';
import React, { useState, useRef, Component } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import VariantesAdminReporteTable from "../VariantesAdminReporte/VariantesAdminReporteTable"
import { VariantesAdminReporteView } from "./VariantesAdminReporteView"
import { VariantesAdminReporteDelete } from "./VariantesAdminReporteDelete"
import VariantesAdminReporteService from "./VariantesAdminReporteService"
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';

import { Breadcrumbs } from '../General/Breadcrumbs';
import authService from '../api-authorization/AuthorizeService'

export class VariantesAdminReporte_Index extends Component {
    static displayName = VariantesAdminReporte_Index.name;
    constructor(props) {
        super(props);
        
        this.state = {
            data: [],
            loading: true,
            modalState: false,
            modalHeader: "Cargando",
            modalBody: () => { return (<div>Cargando</div>); },
            modalOperation: 'add',
            modalIsValid: false,
            searchModel: { iD_Paleta: "", containeR_NUM: "", loaD_PORT: "", description: "", grower: "", viaje: ""  },
            semana: {},
            navieras: [],
            barcos: [],
            productores: [],
            tiposFruta: [],
            barcosViaje: [],
            destinos: [],
            contenedores: [],
            numerosPaleta:[],
            semanasProveedor:[],
        };
        this.load_semana = this.load_semana.bind(this);
        this.load_navieras = this.load_navieras.bind(this);
        this.load_barcos = this.load_barcos.bind(this);
        this.load_semanasProveedor = this.load_semanasProveedor.bind(this);
        this.populateData = this.populateData.bind(this);
        this.modalBodyState = {};
        this.modalToggle = this.modalToggle.bind(this);
        this.add_onclick = this.add_onclick.bind(this);
        this.add_modal_guardar_onclick = this.add_modal_guardar_onclick.bind(this);
        this.edit_onclick = this.edit_onclick.bind(this);
        this.edit_modal_guardar_onclick = this.edit_modal_guardar_onclick.bind(this);
        this.delete_onclick = this.delete_onclick.bind(this);
        this.delete_modal_guardar_onclick = this.delete_modal_guardar_onclick.bind(this);
        this.setModalBodyState = this.setModalBodyState.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.clean_onclick = this.clean_onclick.bind(this);
        this.printReport = this.printReport.bind(this);
    }

    componentDidMount() {
        this.populateData();
    }

    modalToggle() {
        this.setState({
            modalState: !this.state.modalState
        });
    }

    renderTable() {
        return (
            <div  >
                <Row>
                    <Form >
                        <Row>     
                            <Col className="col-auto">
                                <FormGroup>
                                    <Label for="grower">
                                        <FormattedMessage id='Productor' />
                                    </Label>
                                    <Input
                                        id="grower"
                                        name="grower"
                                        type="select"
                                        onChange={this.handleSearchChange}
                                       
                                    >
                                        <option value=""></option>
                                        {this.state.productores.map(grower => grower == this.state.searchModel.grower ? (
                                            <option value={grower} selected>
                                                {grower}
                                            </option>
                                        ) : (<option value={grower}>{grower}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <Label for="description">
                                        <FormattedMessage id='Tipo de fruta' />
                                    </Label>
                                    <Input
                                        id="description"
                                        name="description"
                                        type="select"
                                        onChange={this.handleSearchChange}
                     
                                    >
                                        <option value=""></option>
                                        {this.state.tiposFruta.map(description => description == this.state.searchModel.description ? (
                                            <option value={description} selected>
                                                {description}
                                            </option>
                                        ) : (<option value={description}>{description}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <Label for="viaje">
                                        <FormattedMessage id='Viaje' />
                                    </Label>
                                    <Input
                                        id="viaje"
                                        name="viaje"
                                        type="select"
                                        onChange={this.handleSearchChange}

                                    >
                                        <option value=""></option>
                                        {this.state.barcosViaje.map(viaje => viaje == this.state.searchModel.viaje ? (
                                            <option value={viaje} selected>
                                                {viaje}
                                            </option>
                                        ) : (<option value={viaje}>{viaje}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <Label for="loaD_PORT">
                                        <FormattedMessage id='Destino' />
                                    </Label>
                                    <Input
                                        id="loaD_PORT"
                                        name="loaD_PORT"
                                        type="select"
                                        onChange={this.handleSearchChange}
                                    >
                                        <option value=""></option>
                                        {this.state.destinos.map(destino => destino == this.state.searchModel.loaD_PORT ? (
                                            <option value={destino} selected>
                                                {destino}
                                            </option>
                                        ) : (<option value={destino}>{destino}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="iD_Paleta">
                                        <FormattedMessage id='ID Paleta' />
                                    </Label>
                                    <FormattedMessage id='ID Paleta'>
                                        {(placeholder) =>
                                            <Input
                                                id="iD_Paleta"
                                                name="iD_Paleta"
                                                //placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleSearchChange}
                                                value={this.state.searchModel.iD_Paleta}
                                            />
                                        }
                                    </FormattedMessage>

                                </FormGroup>
                            </Col>
                            
                            <Col md="2">
                                <FormGroup>
                                    <Label for="containeR_NUM">
                                        <FormattedMessage id='Contenedor' />
                                    </Label>
                                    <FormattedMessage id='Contenedor'>
                                        {(placeholder) =>
                                            <Input
                                                id="containeR_NUM"
                                                name="containeR_NUM"
                                                //placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleSearchChange}
                                                value={this.state.searchModel.containeR_NUM}
                                            />
                                        }
                                    </FormattedMessage>

                                </FormGroup>
                            </Col>
                            
                            <Col className="col-auto">
                                <FormGroup>
                                    <IconButton size='small' className='SearchButton IndexButton' onClick={this.populateData}>
                                        <SearchIcon />
                                    </IconButton>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <Button className="DownloadButton IndexButton" onClick={this.printReport}>
                                        <DownloadOutlinedIcon fontSize='large' /> <FormattedMessage id='Descargar' />
                                    </Button>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <Button className="CleanButton IndexButton" onClick={this.clean_onclick}>
                                        <CachedOutlinedIcon fontSize='large' /> <FormattedMessage id='Limpiar' />
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </Row>
                <Row className="my-2">
                    <VariantesAdminReporteTable data={this.state.data} add_onclick={this.add_onclick} edit_onclick={this.edit_onclick} delete_onclick={this.delete_onclick} />
                </Row>
                <Modal size="lg" isOpen={this.state.modalState} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>
                        {this.state.modalHeader}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.modalBody}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.modalSubmit} disabled={!this.state.modalIsValid}>
                            {this.state.modalOperation == 'delete' ? <FormattedMessage id='Eliminar' /> : <FormattedMessage id='Guardar' />}
                        </Button>{' '}
                        <Button color="secondary" onClick={this.modalToggle}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    render() {
        let breadcrumbsData = this.state.loading
            ? <p></p>
            : <Breadcrumbs data={[
                { link: "/SemanasAdmin", message: "Semanas", active: true },
                { link: "/Semanas/" + this.state.semana.semana_Id + "/ResumenDeCargas", message: "ResumenDeCargas", active: false },
            ]} />;
        let contents = this.state.loading
            ? <p><em>Cargando...</em></p>
            : this.renderTable();

        return (
            <div style={{ width: '100%' }}>
                <h2><FormattedMessage id='ResumenDeCargas' /></h2>
                {breadcrumbsData}
                
                <div className="viewContainerHeader ">
                    <div className="d-flex justify-content-start">
                        <div className="px-4 py-2"><FormattedMessage id='Semana' />: {this.state.semana.nombre}</div>
                        {/*<div className="px-4 py-2"><FormattedMessage id='Barco' />: {this.state.contenedorSemanal.barco}</div>*/}
                    </div>
                    <div className="d-flex justify-content-start">
                        {/*<div className="px-4 py-2"><FormattedMessage id='Proveedor' />: {this.state.proveedor.producto}</div>*/}
                        {/*<div className="px-4 py-2"><FormattedMessage id='Contenedor' />: {this.state.contenedorSemanal.contenedor}</div>*/}
                        {/*<div className="px-4 py-2"><FormattedMessage id='EtiquetaEspecial' />: {this.state.contenedorSemanal.etiquetaEspecial}</div>*/}
                    </div>
                </div>
                <div className="viewContainer-lg">
                    {contents}
                </div>

            </div>
        );
    }

    async populateData() {
        this.setState({
            loading: true, semana: await this.load_semana(), navieras: await this.load_navieras(), semanasProveedor: await this.load_semanasProveedor()
        },
            async () => {
            const token = await authService.getAccessToken();
            var queryString = '?semana_Id=' + this.state.semana.semana_Id;
            const response = await fetch('api/VariantesAdminReporte' + queryString, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            });
            const responceData = await response.json();
            const productores = responceData.map(item => item.grower).filter((value, index, self) => self.indexOf(value) === index);
            const tiposFruta = responceData.map(item => item.description).filter((value, index, self) => self.indexOf(value) === index);
            const barcosViaje = responceData.map(item => item.vesseL_NAME + " - " + item.voyagE_NUMBER).filter((value, index, self) => self.indexOf(value) === index);
            const destinos = responceData.map(item => item.loaD_PORT).filter((value, index, self) => self.indexOf(value) === index);
            const contenedores = responceData.map(item => item.containeR_NUM).filter((value, index, self) => self.indexOf(value) === index);
            const numerosPaleta = responceData.map(item => item.iD_Paleta).filter((value, index, self) => self.indexOf(value) === index);

            let data = responceData;
            if (this.state.searchModel.iD_Paleta != "") {
                data = data.filter(x => x.iD_Paleta.includes(this.state.searchModel.iD_Paleta));
            }
            if (this.state.searchModel.containeR_NUM != "") {
                data = data.filter(x => x.containeR_NUM.includes(this.state.searchModel.containeR_NUM));
            }
            if (this.state.searchModel.loaD_PORT != "") {
                data = data.filter(x => x.loaD_PORT == this.state.searchModel.loaD_PORT);
            }
            if (this.state.searchModel.description != "") {
                data = data.filter(x => x.description == this.state.searchModel.description);
            }
            if (this.state.searchModel.grower != "") {
                data = data.filter(x => x.grower == this.state.searchModel.grower);
            }
            if (this.state.searchModel.viaje != "") {
                data = data.filter(x => x.vesseL_NAME + " - " + x.voyagE_NUMBER == this.state.searchModel.viaje);
            }

            this.setState({ data: data, productores, tiposFruta, barcosViaje, destinos, contenedores, numerosPaleta, loading: false });

        });
    }

    async handleSearchChange(event) {
        event.preventDefault();
        var searchModel = this.state.searchModel;
        searchModel[event.target.name] = event.target.value;
        this.setState({ searchModel: searchModel }, async () => {
            if (event.target.name == "naviera_Id") {
                this.setState({
                    barcos: await this.load_barcos()
                });
            }
        });

    }
    async modalSubmit(id) {
        if (this.state.modalOperation == 'add') {
            this.add_modal_guardar_onclick();
        }
        else if (this.state.modalOperation == 'edit') {
            this.edit_modal_guardar_onclick(id);
        }
        else if (this.state.modalOperation == 'delete') {
            this.delete_modal_guardar_onclick(id);
        }
    }
    async add_onclick() {
        this.setState({
            modalHeader: this.add_modal_header(),
            modalBody: this.add_modal_body(),
            modalState: true,
            modalOperation: 'add',
        });
    }
    add_modal_header() {
        return (<div><FormattedMessage id='Nuevo' /></div>);
    }
    add_modal_body() {
        return (<div><VariantesAdminReporteView operation={this.state.modalOperation} setModalBodyState={this.setModalBodyState}></VariantesAdminReporteView></div>);
        //return (<div><VariantesAdminReporteView ref={this.modalBodyState}></VariantesAdminReporteView></div>);
    }
    async add_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/variantesAdminReporte', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
        //const responceData = await response.json();
    }
    async edit_onclick(id) {
        const modalBody = await this.edit_modal_body(id);
        this.setState({
            modalHeader: this.edit_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'edit',
        });
    }
    edit_modal_header(id) {
        return (<div><FormattedMessage id='Editar' /></div>);
    }
    async edit_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/variantesAdminReporte/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        return (<div><VariantesAdminReporteView operation={ this.state.modalOperation} setModalBodyState={this.setModalBodyState} data={responceData}></VariantesAdminReporteView></div>);
        //return (<div><VariantesAdminReporteView ref={this.modalBodyState}></VariantesAdminReporteView></div>);
    }
    async edit_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/variantesAdminReporte/' + this.modalBodyState.varianteAdminReporte_Id, {
            method: 'PUT',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async delete_onclick(id) {
        const modalBody = await this.delete_modal_body(id);
        this.setState({
            modalHeader: this.delete_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'delete',
            modalIsValid: true
        });
    }
    delete_modal_header(id) {
        return (<div><FormattedMessage id='Eliminar' /></div>);
    }
    async delete_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/variantesAdminReporte/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        await this.setModalBodyState({ model: responceData });
        return (<div><VariantesAdminReporteDelete setModalBodyState={this.setModalBodyState} data={responceData}></VariantesAdminReporteDelete></div>);
    }
    async delete_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/variantesAdminReporte/' + this.modalBodyState.varianteAdminReporte_Id, {
            method: 'DELETE',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async clean_onclick() {
        this.setState({
            searchModel: { iD_Paleta: "", containeR_NUM: "", loaD_PORT: "", description: "", grower: "", viaje: "" },
        });
        await this.populateData()
    }

    async setModalBodyState(state) {
        this.modalBodyState = state.model;
        if (state.modelValidation) {
            var modalIsValid = !Object.keys(state.modelValidation).some(function (val) {
                return state.modelValidation[val] == false;
            });
            this.setState({
                modalIsValid: modalIsValid
            });
        }

    }
    async load_semana() {
        var rawUrl = window.location.toString();
        var semana_Id = rawUrl.split("Semanas/")[1].split("/")[0];
        const token = await authService.getAccessToken();
        const response = await fetch('api/semanas/' + semana_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_navieras() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/navieras/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_barcos() {
        if (this.state.searchModel.naviera_Id != 0) {
            const token = await authService.getAccessToken();
            const response = await fetch('api/barcos?naviera_Id=' + this.state.searchModel.naviera_Id, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            });
            return await response.json();
        }
        else {
            return [];
        }
    }
    async load_semanasProveedor() {
        if (this.state.searchModel.naviera_Id != 0) {
            const token = await authService.getAccessToken();
            var rawUrl = window.location.toString();
            var semana_Id = rawUrl.split("Semanas/")[1].split("/")[0];
            const response = await fetch('api/SemanasProveedor?semanaProveedor_Id=0&semana_Id=' + semana_Id, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            });
            return await response.json();
        }
        else {
            return [];
        }
    }
    async printReport() {
        console.log("printReport");
        await new VariantesAdminReporteService().VariantesAdminReporte(this.state.semana);
        console.log("end");
    }
}